require(
  [
    'testimonialsInitializer',
  ]
);

define("nhs/views/BuilderShowCaseRedesign/ShowTestimonials", function(){});

